


















































import Component from 'vue-class-component'
import Vue from 'vue'
import axios from 'axios'

import userModule from '@/store/user'
import CategoryCard from '@/components/category/CategoryCard.vue'
import { Category } from '@/types/Types'
import { CategoryType } from '@/utils/enums'

@Component({
  name: 'CategoryView',
  components: {
    CategoryCard
  }
})
class CategoryView extends Vue {
  private categories: Category[] = []
  private chosenLocal: string[] = []
  private chosenOnline: string[] = []

  private get localCategories(): Category[] {
    return this.categories.filter(
      category => category.type === CategoryType.LOCAL
    )
  }

  private get onlineCategories(): Category[] {
    return this.categories.filter(
      category => category.type === CategoryType.ONLINE
    )
  }

  private get isValidSelection(): boolean {
    return this.chosenLocal.length < 3 || this.chosenOnline.length < 3
  }

  private async created(): Promise<void> {
    const { data } = await axios.get('/categories')
    this.categories = data.categories
  }

  private handleCategory(id: string, type: string): void {
    const card = this.$refs[`card-${id}`] as Vue[]
    const classList = card[0].$el.classList
    if (classList.contains('category-card-alt')) {
      classList.remove('category-card-alt')

      if (type === CategoryType.LOCAL) {
        this.chosenLocal = this.chosenLocal.filter(category => category !== id)
      } else {
        this.chosenOnline = this.chosenOnline.filter(
          category => category !== id
        )
      }
    } else {
      classList.add('category-card-alt')

      if (type === CategoryType.LOCAL) {
        this.chosenLocal.push(
          this.categories.find(category => category._id === id)!._id
        )
      } else {
        this.chosenOnline.push(
          this.categories.find(category => category._id === id)!._id
        )
      }
    }
  }

  private async saveCategories(): Promise<void> {
    await userModule.update({
      categories: this.chosenLocal.concat(this.chosenOnline)
    })
    this.$router.push({ name: 'HomeView' })
  }
}

export default CategoryView
